'use client';

import { Alignable, Icon, IconName, Spacer, SpacerSize, Tab, TabList, Tabs } from '@bytel/trilogy-react';

import { HomePackResponseWithCategories, PACK_HASH } from '@app-types/home-pack';

import { useTabsOverflow } from '@hooks/use-tabs-overflow';

import { replaceWindowUrl } from '@helpers/document';
import { paths } from '@helpers/path';

type PackHashKeys = keyof typeof PACK_HASH;
type HomePackProps = {
    currentHash: PACK_HASH;
    staticsCategories?: HomePackResponseWithCategories;
    setSlug: (slug: string) => void;
};

export function HomePackTabs({ currentHash, staticsCategories, setSlug }: HomePackProps) {
    const { tabsRef, arrowRef } = useTabsOverflow();

    if (
        !staticsCategories ||
        !staticsCategories.categoryProductsSamsung ||
        !staticsCategories.categoryProductsSamsung.length
    ) {
        return null;
    }

    const handleTabChange = (slug: string) => {
        const url = `${paths.homePack}/${slug}`;
        setSlug(slug);
        replaceWindowUrl(url);
    };

    return (
        <Tabs onClick={function noRefCheck() {}} className='is-flex is-aligned-center is-justified-center'>
            <TabList align={Alignable.ALIGNED_CENTER} ref={tabsRef}>
                {staticsCategories.categoryProductsSamsung
                    ?.filter(
                        (productCategory) =>
                            productCategory.categoryName && (productCategory.productsSamsung?.length || 0) > 0,
                    )
                    ?.sort((a, b) => a.order - b.order)
                    ?.map((productCategory) => {
                        const slugKey = productCategory.slug?.toUpperCase() as PackHashKeys;
                        return (
                            <Tab
                                routerLink='a'
                                key={productCategory.id}
                                label={productCategory.categoryName!}
                                onClick={(e) => {
                                    (e as Event).preventDefault();
                                    handleTabChange(productCategory.slug!);
                                }}
                                id={productCategory.slug}
                                active={currentHash.toUpperCase() === slugKey.toUpperCase()}
                                href={`${paths.homePack}/${productCategory.slug}`}
                                iconName={productCategory.icon}
                            />
                        );
                    })}
            </TabList>
            <Spacer size={SpacerSize.THREE} horizontal />
            <Icon name={IconName.ARROW_RIGHT} ref={arrowRef} className='is-hidden' />
        </Tabs>
    );
}
